<template>
  <div class="mso-suppliers responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'msoSuppliers', label: 'MSO Supplier' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"/>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "msoSuppliers",
  data() {
    return {
      listPageHeader,
      entity: Entities.MSOSUPPLIER,
    };
  },
  mounted: function () {
    this.setPageTitle("MSOSuppliers");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "msoSupplierModule/sort",
      pagination: "msoSupplierModule/pagination",
      initialFilter: "msoSupplierModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "msoSupplierModule/updateSort",
      updatePagination: "msoSupplierModule/updatePagination",
      updateInitialFilter: "msoSupplierModule/updateInitialFilter"
    }),
  }
};
</script>
